import React from 'react';
import { Card, CardContent } from '@/components/ui';

export interface SitePhoto {
  id: string;
  url: string;
  timestamp: string;
}

interface SitePhotosProps {
  photos?: SitePhoto[];
  isLoading?: boolean;
}

export function SitePhotos({ photos, isLoading }: SitePhotosProps) {
  const defaultPhotos: SitePhoto[] = [
    { id: '1', url: 'https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?q=80&w=300&auto=format&fit=crop', timestamp: '08:15' },
    { id: '2', url: 'https://images.unsplash.com/photo-1558905619-1581e289051d?q=80&w=300&auto=format&fit=crop', timestamp: '08:30' },
    { id: '3', url: 'https://images.unsplash.com/photo-1589923188900-85dae523342b?q=80&w=300&auto=format&fit=crop', timestamp: '08:45' },
    { id: '4', url: 'https://images.unsplash.com/photo-1598902108854-10e335adac99?q=80&w=300&auto=format&fit=crop', timestamp: '10:20' },
    { id: '5', url: 'https://images.unsplash.com/photo-1591857177580-dc82b9ac4e17?q=80&w=300&auto=format&fit=crop', timestamp: '13:40' },
    { id: '6', url: 'https://images.unsplash.com/photo-1601321040778-9e19669527ec?q=80&w=300&auto=format&fit=crop', timestamp: '14:10' },
  ];

  const displayPhotos = photos || defaultPhotos;

  return (
    <Card className="border-none shadow-sm h-full">
      <CardContent className="p-6">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-sm font-bold text-slate-800">Ảnh hiện trường cập nhật</h3>
          <button className="text-[10px] font-bold text-emerald-600 hover:underline">Xem tất cả</button>
        </div>

        <div className="grid grid-cols-3 gap-3">
          {displayPhotos.map((photo) => (
            <div key={photo.id} className="relative aspect-video rounded-lg overflow-hidden group cursor-pointer">
              <img 
                src={photo.url} 
                alt="Site" 
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" 
              />
              <div className="absolute bottom-2 left-2 px-1.5 py-0.5 bg-black/60 backdrop-blur-sm rounded text-[9px] font-bold text-white">
                {photo.timestamp}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
